import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";
import { ExamTypeCategory } from "./type";

export const examTypeCategoryLoader: LoaderFunction = async (args) => {
  if (args.params.assignmentPeriodCode === "new") {
    return new Promise((res) => res(Result.newResult()));
  }
  const result = await axiosApi.get<Result<ExamTypeCategory>>(
    `/api/examTypeCategories/${args.params.examTypeCode}/${args.params.categoryCode}`
  );
  return result.data;
};
